import type { Guard } from "./types";
import { useMimboxesStore } from "@/stores/mimboxes";
import { useWashingMachinesStore } from "@/stores/washingmachines";
import { invitedConverter } from "@mimsights-shared/converters/frontend";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../mixins/firebase";

const PATH_404 = {
  name: "404",
} as const;

export const requireMimboxToExist: Guard = async (to, _from) => {
  const qrCodeId = to.params.id as string;
  if (!qrCodeId) return PATH_404;

  const { collection, doc, getDoc } = await import("firebase/firestore");
  const { db } = await import("../mixins/firebase");

  const documentRef = doc(collection(db, "qr_codes"), qrCodeId);
  const qrCodeMetadataDocument = await getDoc(documentRef);
  if (!qrCodeMetadataDocument.exists()) {
    return PATH_404;
  }
  const qrCodeMetadata = qrCodeMetadataDocument.data() as {
    mimbox_id?: string;
  };
  if (!qrCodeMetadata.mimbox_id) {
    return {
      name: "qr-code-waiting",
      params: { id: qrCodeId },
    };
  }
  return true;
};

export const isInvited: Guard = async (to, _from) => {
  const id = to.params.id as string;
  if (!id) {
    return PATH_404;
  }

  const { doc, getDoc } = await import("firebase/firestore");
  const { db } = await import("../mixins/firebase");
  const invitedDoc = doc(db, "invited", id).withConverter(invitedConverter);
  const invitedSnap = await getDoc(invitedDoc);
  if (!invitedSnap.exists()) {
    return PATH_404;
  }
};

export const hasNoActiveInstallation: Guard = async (to, _from) => {
  const mimboxesStore = useMimboxesStore();
  try {
    if (await (mimboxesStore as any).isInstalled(to.params.id)) {
      return true;
    }
  } catch (e) {
    console.error(e);
  }

  return { path: `/mimbox/${to.params.id}/public` };
};

export const mimboxExists: Guard = async (to, _from) => {
  const id = to.params.id as string;
  if (!id) {
    return PATH_404;
  }

  const mimboxDoc = doc(db, "mimboxes", id);
  const mimboxSnap = await getDoc(mimboxDoc);

  if (!mimboxSnap.exists()) {
    return PATH_404;
  }
  return true;
};

export const organizationOrCustomerExists: Guard = async (to) => {
  const id = to.params.id as string;
  if (!id) {
    return PATH_404;
  }
  const orgsAndCustDoc = doc(db, "organizations_and_customers", id);
  const orgsAndCustSnap = await getDoc(orgsAndCustDoc);
  if (!orgsAndCustSnap.exists()) {
    return PATH_404;
  }
  return true;
};

export const setSelectedWashingMachine: Guard = async (to, _from) => {
  const washingMachinesStore = useWashingMachinesStore();
  try {
    await washingMachinesStore.selectWashingMachine(to.params.id as string);
    return true;
  } catch (e) {
    console.error(e);
    return { path: "/404" };
  }
};
